import React from 'react';
import './cta.scss';

const Cta = ({ title, subtitle, primaryButton, secondaryButton, children }) => {
  return (
    <section className="cta py-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 mx-auto text-center">
            <h2 className="cta__title" dangerouslySetInnerHTML={{ __html: title }}></h2>
            {subtitle && <p className="cta__text">{subtitle}</p>}
            {children}
            <div className="cta__actions">
              {primaryButton && (
                <button className="btn btn-gradient btn-lg me-3" onClick={primaryButton.onClick}>
                  {primaryButton.text}
                </button>
              )}
              {secondaryButton && (
                <button className="btn btn-outline-primary btn-lg" onClick={secondaryButton.onClick}>
                  {secondaryButton.text}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Cta; 